import {Component,Input} from '@angular/core';

/**
 * Composant d'affichage d'une checkbox pour le composant d'affichage hiérarchique
 *
 * @author Laurent SCIMIA
 * @date 11/12/2023
 */
@Component({
	host: {'data-test-id': 'checkbox-detail'},
	templateUrl: './checkbox-detail.component.html',
	styleUrls: ['./checkbox-detail.component.scss']
})
export class CheckboxDetailComponent {
	/** Paramètres du composant reçus depuis la factory du ComponentHolderComponent */
	@Input() input: Record<'element'|'subject'|'checked',any>;

	/**
	 * Action déclenchée lors du clic sur la checkbox
	 */
	clickCheckbox() {
		//Si on a reçu un subject en paramètre
		if (this.input.subject) {
			//On délègue la gestion du clic au subject
			this.input.subject.next(this.input.element);
		} else {
			//Pas de subject, on check la box
			this.checked = !this.checked;
		}
	}

	/**
	 * Récupération de l'état de la checkbox
	 */
	get checked(): boolean {
		//Soit le statut 'checked' est géré via l'input
		if (this.input.checked != null) {
			return this.input.checked;
		} else {
			//Soit c'est celui de l'élément (la branche)
			return this.input.element.checked;
		}
	}

	/**
	 * Modification de l'état de la checkbox
	 *
	 * @param checked Statut coché/décoché
	 */
	set checked(checked: boolean) {
		//Soit le statut 'checked' est géré via l'input
		if (this.input.checked != null) {
			this.input.checked = checked;
		} else {
			//Soit c'est celui de l'élément (la branche)
			this.input.element.checked = checked;
		}
	}
}